import React from 'react';
import style from './style.less';

interface Props {
    labels: string[] | JSX.Element[],
    color?: string
}
export default function BulletsDropdownItem(props: Props) {
    const { labels, color } = props;
    const labelStyle = color ? { color } : {};
    return (
        <div className={style['bullets-dropdown-item-box']}>
            {
                labels.map((label: string | JSX.Element, index: number) => (
                    <div className={style.item} key={index}>
                        <span className={style['item-label']} style={labelStyle}>{label}</span>
                        <span className={style['item-content']}></span>
                    </div>
                ))
            }
        </div>
    );
}
